var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UPLOAD_ZONE_MAPPING_REQUEST, uploadZoneMappingFailure, uploadZoneMappingSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onUploadZoneMappingFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.formUpload(`/rms/admin/upload/zone?tenantId=${action.payload.tenantId}&carrier=${action.payload.carrier}`, {
                file: action.payload.file,
            })
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* UploadZoneMappingFileWorker(action) {
    try {
        const data = yield call(onUploadZoneMappingFile, action);
        yield put(uploadZoneMappingSuccess(data));
    }
    catch (error) {
        yield put(uploadZoneMappingFailure(error));
    }
}
export function* watchUploadZoneMappingFileData() {
    yield takeLatest(UPLOAD_ZONE_MAPPING_REQUEST, UploadZoneMappingFileWorker);
}
